import { memo } from 'react';

import { Tooltip } from 'antd';

import { ConceptLabel, ProductName, Size } from './styles';

interface Props {
  longName: string;
  size?: Size;
  conceptName?: string;
  reserveConceptSpace?: boolean;
}

function InfoProductName({
  longName,
  size = 'medium',
  conceptName,
  reserveConceptSpace = false,
}: Props) {
  return (
    <>
      <Tooltip title={longName}>
        <ProductName size={size}>{longName}</ProductName>
      </Tooltip>
      {conceptName ? (
        <Tooltip title={conceptName}>
          <ConceptLabel size={size}>{conceptName}</ConceptLabel>
        </Tooltip>
      ) : (
        reserveConceptSpace && <ConceptLabel size={size} aria-hidden />
      )}
    </>
  );
}

export default memo(InfoProductName);
